module.exports = __webpack_public_path__ + "img/close-white.27bc5700.svg";